// import "./Navbar.css";

// export default function Navbar() {
//     const adminName = "Admin User";

//     return (
//         <div className="navbar">
//             <h1>Janseva Prabhuseva Trust Admin</h1>
//             <div className="user-profile">
//                 <div className="avatar">
//                     {adminName.charAt(0)}
//                 </div>
//                 <span>{adminName}</span>
//             </div>
//         </div>
//     );
// }

import "./Navbar.css";
import { useNavigate } from "react-router-dom";

export default function Navbar() {
  const adminName = "Admin User";
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("adminLogin"); // 🔐 logout
    navigate("/login");
  };

  return (
    <div className="navbar">
      <h1>Janseva Prabhuseva Trust Admin</h1>

      <div className="user-profile">
        <div className="avatar">
          {adminName.charAt(0)}
        </div>
        <span>{adminName}</span>

        {/* 🔓 Logout Button */}
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
}
